PJQ.views.projects.UserMessages = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-User-Messages'),
		view: 'inbox'
	},
	events: {
		'click .btn-view-message': 'viewMessageClicked',
		'click .btn-delete-message': 'deleteMessageClicked',
		'click .btn-user-messages-add': 'newMessageClicked',
		'click .btn-user-messages-inbox': 'openInbox',
		'click .btn-user-messages-sent': 'openSent'
	},
	beforeFirstRender: function () {
		if (this.options.userMessageId > 0) {
			let userMessage = new PJQ.models.userMessages.UserMessage({
				userMessageId: this.options.userMessageId
			});
			userMessage.fetch({
				success: _.bind(function () {
					this.viewMessage(userMessage);
				}, this)
			});
			this.options.userMessageId = null;
		}

		if (PJQ.app.session.get('masterUserId') === this.options.project.get('masterUserId')) {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'projects',
						value: this.options.project.id
					},
					{
						endpoint: 'usermessages',
						value: 'stats'
					},
				])
			}).get().done(_.bind(function (data) {
				this.messageStats = data;
				this.render();
			}, this));
			return false;
		}
	},
	afterRender: function () {
		if (this.messageStats != null) {
			this.options.userId = PJQ.app.session.user.id;
			if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PRIVATE_MESSAGING_USER_ID_DEFAULT)) {
				this.options.userId = (PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PRIVATE_MESSAGING_USER_ID_DEFAULT) == 0 ? -1 : PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PRIVATE_MESSAGING_USER_ID_DEFAULT));
			}

			let $userFilter = this.$('select.user-messages-user-filter'),
				totalMessageCount = _.reduce(_.map(this.messageStats, function (stat) {
					return stat.messageCount
				}), function (memo, stat) {
					return memo + stat;
				}, 0);
			$userFilter.append($('<option/>', {
				value: -1,
				text: 'All (' + totalMessageCount.toString() + ')'
			}));

			let myStat = _.find(this.messageStats, function (stat) {
				return stat.userId === PJQ.app.session.user.id
			});
			if (myStat == null) {
				$userFilter.append($('<option/>', {
					value: PJQ.app.session.user.id,
					text: PJQ.app.session.user.get('contactName') + ' (0)'
				}));
			}
			_.each(this.messageStats, _.bind(function (user) {
				$userFilter.append($('<option/>', {
					value: user.userId,
					text: user.contactName + ' (' + user.messageCount.toString() + ')'
				}));
			}, this));

			new PJQ.inputs.Selectpicker({
				el: this.$('select.user-messages-user-filter'),
				isMultiple: false,
				defaultValue: this.options.userId,
				onChange: _.bind(function (value) {
					this.options.userId = value;
					this.refreshView();
				}, this)
			});
		}

		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: this.$('.user-messages-data-table'),
			language: {
				emptyTable: "No messages found"
			},
			autoWidth: false,
			data: null,
			isHideSearch: true,
			order: [1, 'desc'],
			rowGroup: {
				enable: false
			},
			columns: [
				{
					"title": 'Message Info',
					"render": _.bind(function (data, type, row) {
						let rowText = '';
						if (type === 'sort' || type === 'type') {
							if (this.options.view === 'inbox')
								rowText = row.from.get('companyName') + ' ' + row.from.get('contactName') + '<br />' + row.get('userMessageType');
							else
								rowText = row.to.get('companyName') + ' ' + row.to.get('contactName') + '<br />' + row.get('userMessageType');
						}

						if (this.options.view === 'inbox')
							rowText = row.from.get('companyName') + '<br />' + row.from.get('contactName') + '<br />' + row.get('userMessageType');
						else
							rowText = row.to.get('companyName') + '<br />' + row.to.get('contactName') + '<br />' + row.get('userMessageType');

						if (row.get('viewedOn') == null && this.options.view === 'inbox') {
							return '<span class="font-weight-bold">' + rowText + '</span>';
						}
						else {
							return rowText;
						}
					}, this),
					"width": "65%"
				},
				{
					"data": {
						"_": function (row) {
							return new Date(row.get('createdOn'));
						},
						"filter": "attributes.createdOn",
						"display": _.bind(function (row) {
							return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('createdOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
						}, this)
					},
					"render": _.bind(function (data, type, row) {
						if (type === 'sort' || type === 'type') {
							return new Date(row.get('createdOn'));
						}

						let rowText = PJQ.helpers.dateHelpers.getDateString(new Date(row.get('createdOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
						if (row.get('viewedOn') == null && this.options.view === 'inbox') {
							return '<span class="font-weight-bold">' + rowText + '</span>';
						}
						else {
							return rowText;
						}
					}, this),
					"title": "Last Activity",
					"width": "20%"
				},
				{
					"title": '',
					"render": function () {
						if (PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId')) {
							return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-message mr-1" title="View Message"><i class="fal fa-arrow-alt-from-left"></i></button><button type="button" class="btn btn-danger btn-delete-message" title="Delete Message"><i class="fal fa-trash"></i></button></div>';
						}
						else {
							return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-message mr-1" title="View Message"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
						}
					},
					"orderable": false,
					"searchable": false,
					"className": "text-center",
					"width": "80px"
				},
				{
					"data": "from.attributes.companyName",
					"visible": false
				},
				{
					"data": "attributes.userMessageType",
					"visible": false
				}
			],
			pageLength: 10,
			onRowDoubleClick: _.bind(function (row) {
				this.viewMessage(row.data());
			}, this)
		});

		this.refreshView()
	},
	refreshView: function () {
		let $inboxBtn = this.$('.btn-user-messages-inbox'),
			$sentBtn = this.$('.btn-user-messages-sent');
		if (this.options.view === 'inbox') {
			$inboxBtn.removeClass('text-muted');
			$sentBtn.addClass('text-muted');
		}
		else if (this.options.view === 'sent') {
			$sentBtn.removeClass('text-muted');
			$inboxBtn.addClass('text-muted');
		}

		this.collection = new PJQ.collections.userMessages.UserMessages(null, {
			project: this.options.project,
			view: this.options.view,
			userId: this.options.userId
		});
		this.collection.fetch({
			success: _.bind(function () {
				this.dataTable.resetData(this.collection.models);
			}, this)
		});
	},
	openInbox: function () {
		this.options.view = 'inbox';
		this.refreshView();
	},
	openSent: function () {
		this.options.view = 'sent';
		this.refreshView();
	},
	viewMessageClicked: function (e) {
		let message = this.dataTable.getRow($(e.currentTarget).closest('tr')).data();
		if (message != null) {
			this.viewMessage(message);
		}
	},
	viewMessage: function (message) {
		if (message.get('viewedOn') == null) {
			message.updateViewed();
			this.dataTable.refresh();
		}

		new PJQ.views.projects.UserMessageModal({
			project: this.options.project,
			model: message,
			onSend: _.bind(function () {
				this.refreshView();
			}, this)
		});
	},
	newMessageClicked: function () {
		new PJQ.views.projects.UserMessageModal({
			project: this.options.project,
			onSend: _.bind(function () {
				this.openSent();
			}, this)
		});
	},
	deleteMessageClicked: function (e) {
		let row = this.dataTable.getRow($(e.currentTarget).closest('tr')),
			message = row.data();
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this message?",
			onDelete: _.bind(function () {
				this.collection.remove(message);
				message.destroy();
				if (row != null) {
					this.dataTable.removeRow(row);
				}
			}, this)
		});
	}
});

PJQ.views.projects.UserMessageModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-User-Message'),
		maxWidth: '550px',
		onSend: _.noop,
		userMessage: null,
		userMessageTypeId: null
	},
	events: {
		'change select.user-message-type': 'userMessageTypeChanged',
		'keyup .user-message-body': 'valueChanged',
		'keyup .user-message-reply': 'replyChanged',
		'click .btn-reply': 'replyClicked',
		'keyup .user-message-bid-amount': 'valueChanged',
		'click .user-message-close': 'onClose',
		'click .user-message-send': 'onSend',
		'click .user-message-export': 'onExport'
	},
	beforeModalCreated: function () {
		if (this.model == null) {
			this.model = new PJQ.models.userMessages.UserMessage({
				project: this.options.project
			});
		}

		this.options.project.fetchUserMessageTypes(_.bind(function () {
			if (this.model.userMessageType == null) {
				if (this.options.userMessageTypeId != null) {
					this.model.userMessageType = this.options.project.userMessageTypes.get(this.options.userMessageTypeId);
				}

				// we check here in case the previous user message set was null
				if (this.model.userMessageType == null) {
					this.model.userMessageType = this.options.project.userMessageTypes.models[0];
				}
			}

			if (this.model.id > 0) {
				this.thread = new PJQ.collections.userMessages.UserMessageThread(null, {
					message: this.model
				});
				this.thread.fetch({
					success: _.bind(function () {
						if (_.size(this.thread.models) > 0) {
							this.model = _.sortBy(this.thread.models, function (model) {
								return model.id;
							})[0];
						}
						this.listenTo(this.model, 'sync', this.render);
						this.render();
					}, this)
				})
			}
			else {
				this.render();
			}
		}, this));
	},
	beforeRender: function () {
		this.renderData = {
			userMessage: this.model,
			userMessageTypes: this.options.project.userMessageTypes,
			thread: this.thread
		};
	},
	afterRender: function () {
		if (this.model.userMessageType != null) {
			if (this.model.isNew()) {
				new PJQ.inputs.Selectpicker({
					el: this.$('select.user-message-type'),
					defaultValue: this.model.userMessageType.id,
					isMultiple: false,
					onChange: _.bind(function (newValue) {
						this.model.userMessageType = this.options.project.userMessageTypes.get(newValue);
						this.render();
					}, this)
				});
			}
		}

		if ((this.model.isNew() || _.size(this.model.attachments.models) > 0) && this.$('.user-message-files').length > 0) {
			this.uploader = new PJQ.views.files.FileUploaderGrid({
				el: this.$('.user-message-files'),
				collection: this.model.attachments,
				canUpload: this.model.isNew(),
				canDelete: this.model.isNew(),
				onSuccess: _.bind(function (file) {
					this.valueChanged();
				}, this),
				afterDelete: _.bind(function () {
					this.valueChanged();
				}, this)
			});
		}

		if (!this.model.isNew()) {
			this.replyUploader = new PJQ.views.files.FileUploaderGrid({
				el: this.$('.uploader-reply'),
				style: 'list',
				isSmall: true
			});
		}
	},
	replyChanged: function (e) {
		this.$('.btn-reply').prop('disabled', _.size($(e.currentTarget).val()) === 0);
	},
	replyClicked: function () {
		let newMessage = new PJQ.models.userMessages.UserMessage({
			project: this.model.project,
			replyToMessageId: this.model.id,
			body: this.$('.user-message-reply').val(),
			attachments: this.replyUploader.collection.models
		});
		this.thread.add(newMessage);
		newMessage.save(null, {
			success: _.bind(function () {
				this.render();
			}, this)
		})
	},
	valueChanged: function () {
		let canSend = true;
		if (this.model.userMessageType.get('isShowBidAmount') && _.size(this.$('.user-message-bid-amount').val()) === 0)
			canSend = false;
		if (!this.model.userMessageType.get('isAttachmentOnly') && _.size(this.$('.user-message-body').val()) === 0)
			canSend = false;
		if (this.model.userMessageType.get('isAttachmentOnly') && this.uploader.collection.length === 0)
			canSend = false;
		if (this.model.userMessageType.get('isAttachmentRequired') && this.uploader.collection.length === 0)
			canSend = false;

		this.$('.user-message-send').prop('disabled', !canSend);
	},
	onClose: function () {
		this.removeModal();
	},
	onSend: function () {
		// Disable send button to avoid double sending message
		this.$('.user-message-send').attr('disabled', 'true');

		if (this.model.userMessageType.get('isShowBidAmount'))
			this.model.set('bidAmount', parseInt(this.$('.user-message-bid-amount').val()));

		this.model.save({
			body: this.$('.user-message-body').val(),
		}, {
			success: _.bind(function () {
				this.removeModal();
				if (typeof this.options.onSend === 'function')
					this.options.onSend();
			}, this),
			error: _.bind(function(){
				//Re-enable if the message fails for some reason
				this.$('.user-message-send').attr('disabled', false);
			}, this)
		});
	},
	onExport: function() {
		PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'usermessages',
				value: this.model.id
			},
			{
				endpoint: 'thread'
			},
			{
				endpoint: 'export'
			}
		]));

	}
});
